/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button, Col, Label, FormGroup } from 'reactstrap';
import { Redirect } from 'react-router-dom';
// import {FaQuestionCircle} from 'react-icons/fa';
import '../../../../../Assets/EnsembleStyles/Administration/addmodifyuser.css';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import { AddNewBuildings } from '../../../../../action/Administration/administrationAction';
import * as ErrorMessage from '../../../../../Resources/ErrorMessages';
import { getCommonResources_Action } from '../../../../../action/cultureAction';




class AddNewBuilding extends Component {

    componentWillMount() {
        this.props.getCommonResources_Action();
        if(this.props.Common_Resource_from_Store !== null){
            this.selectCountry(this.props.Common_Resource_from_Store,228);
           }  
    }
      

    constructor(props) {
        super(props)
        this.state = {
            name_state: "",
            city_state: "",
            country_state: "",
            state_state: "",
            timezone_state: "",
            SerialNumber_state: "",
            User_name_State: "",
            Password_State: "",
            error_msg:false,
            redirectHome: false,
            add_new_buildings_state:null,
            error_Code:0,
            username_error:false,
            password_error:false,
            common_resource_data_in_state:null,
            countries_list_from_resource_in_state:null,
            states_list_from_resource_in_state:null,
            timezones_list_from_resource_in_state:null
        }
        this.AddBuilding_Submit = this.AddBuilding_Submit.bind(this);
        this.GoBack = this.GoBack.bind(this);
        this.selectCountry = this.selectCountry.bind(this);

    }

    GoBack(){
        this.setState({redirectHome: true});
      }

      componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({ add_new_buildings_state: nextProps.Add_New_Buildings_response });
            if(nextProps.Common_Resource_from_Store !== null){
                this.setState({ common_resource_data_in_state: nextProps.Common_Resource_from_Store });
                this.selectCountry(nextProps.Common_Resource_from_Store,228);
            }
        }
    }

   


    selectCountry(Whole_Data, default_index) {
        let {states_list_from_resource_in_state } = this.state; //eslint-disable-line
        let white_listed_states,subset,states_List = null;
        let selected_country_index;

        

        if(Whole_Data !== null){
            white_listed_states = Object.keys(Whole_Data).filter(function (filtered_data) {
                return filtered_data.indexOf('StateName') == 0;
            }).reduce(function (Data, filtered_data) {
                Data[filtered_data] = Whole_Data[filtered_data];
                return Data;
            }, {});
        
            states_List = Object.values(white_listed_states).map((option, index) =>
                    <option key={index} value={option} selected={index === 1 ? true : false}>
                        {option}
                    </option>
            )

            
            if(this.refs.select_country != undefined){
               selected_country_index = this.refs.select_country.options.selectedIndex; 
            }
            if(default_index != null){
                selected_country_index = 228;
            }

            if(selected_country_index == 228){  // Selected event is united states
                subset =  states_List.slice(0,49);
            }
            else if(selected_country_index == 39){    //Selected event is Canada
                subset = states_List.slice(49,64);
            }
            else{
                subset = null;
            }
            this.setState({ states_list_from_resource_in_state: subset});
        }
       
    }





    AddBuilding_Submit() {
        let {name_state,city_state,SerialNumber_state,User_name_State,Password_State} = this.state;

        this.setState({
            error_msg: false, error_msg_type:null,error_Code:0,username_error:false,password_error:false
        });

        if(name_state === "" ||name_state === undefined ||city_state === "" ||city_state === undefined ||SerialNumber_state === "" ||SerialNumber_state === undefined || User_name_State === "" || User_name_State === undefined || Password_State === "" || Password_State === undefined){
            let l_Error_Code = 0;
            if(name_state === "" ||name_state === undefined)
            {
                l_Error_Code += 1;
            }
            if(city_state === "" ||city_state === undefined)
            {
                l_Error_Code += 10;
            }
            if(SerialNumber_state === "" ||SerialNumber_state === undefined)
            {
                l_Error_Code += 100;
            }
            if(User_name_State === "" || User_name_State === undefined)
                this.setState({username_error:true});
            if(Password_State === "" || Password_State === undefined)
                this.setState({password_error:true});

            this.setState({  error_msg: true, error_Code: l_Error_Code });
        }
        else{
            let states = "";
            let selected_country_index = this.refs.select_country.options.selectedIndex; 
            let country = this.refs.select_country.options[selected_country_index].value;

            let selected_state_index = this.refs.select_state.options.selectedIndex; 
            if(selected_state_index !== -1){
                 states = this.refs.select_state.options[selected_state_index].value;
            }
            
            let zone = this.add_building_timezone.value; 
            if(country==="United States"){
                 zone = this.add_building_timezone.value; 
            }
             
            let daylightsaving = this.add_daylightsaving.value;

            let l_serialNumbers = [];
            if(SerialNumber_state.indexOf(',') !== -1){
                l_serialNumbers = SerialNumber_state.split(',');
            }else{
                l_serialNumbers.push(SerialNumber_state);
            }

            var data=   {
                "siteName": name_state,
                "serialNumbers":l_serialNumbers,
                "addressCity": city_state,
                "addressState": states,
                "addressCountry": country,
                "timeZone": zone,
                "isDaylightSavingTimeEnabled":daylightsaving,
                "protocolType":4,
                "portNumber":Math.floor(Math.random() * (5000 - 1000 + 1) ) + 1000,
                "deviceIdRanges": null,
                "userName": User_name_State,
                "password": Password_State
                }
          this.props.AddNewBuildings(data);
     }
    }


    render(Common_Resource_from_Store) {

        let Error_Message, white_listed_countries, List_of_countries, Whole_Data  = null;
        let {add_new_buildings_state, common_resource_data_in_state, states_list_from_resource_in_state } = this.state;


       if(this.props.Common_Resource_from_Store !== null){
        Whole_Data =  this.props.Common_Resource_from_Store;
       }       
        else if (common_resource_data_in_state !== null){
            Whole_Data =  common_resource_data_in_state;
        }
        if (Whole_Data !== null) {
            white_listed_countries = Object.keys(Whole_Data).filter(function (filtered_data) {
                return filtered_data.indexOf('CountryName') == 0;
            }).reduce(function (Data, filtered_data) {
                Data[filtered_data] = Whole_Data[filtered_data];
                return Data;
            }, {});

            if (white_listed_countries !== null  ) {
                List_of_countries = Object.values(white_listed_countries).map((option, index) =>
                    // <option key={index} value={option} selected={option === "United States " ? true : false}>
                    <option key={index} name={index} value={option} selected={option === "United States " ? true : false}>
                        {option}
                    </option>
                )
            }


        }




        
       (this.state.error_msg == true) ? Error_Message = <p className="error_msg login_error_msg "> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.no_values_with_mark}</p> : Error_Message = "";
        
       if(add_new_buildings_state !== null){

       if( "errorCode" in add_new_buildings_state.data){
       Error_Message = <p className="error_msg login_error_msg "> <img src={ErrorGif} alt="Trane Logo" />  
       {add_new_buildings_state.data.errorCode == 25 ? ErrorMessage.ErrorCode_25+ add_new_buildings_state.data.errorBuilding +" .  Please use a unique Serial numbers." : 
       (add_new_buildings_state.data.errorCode == 10) ? ErrorMessage.ErrorCode_10 : 
       (add_new_buildings_state.data.errorCode == 26) ? ErrorMessage.ErrorCode_26 : 
       (add_new_buildings_state.data.errorCode == 27) ? ErrorMessage.ErrorCode_27 :
       add_new_buildings_state.data.errorDescription}</p>;
           }
           if( "currentPanelId" in add_new_buildings_state.data){
                  return <Redirect to={"/SystemAdmin/BuildingInstallation"} />
             }
       }
       if(this.state.redirectHome){
        return <Redirect to={"/SystemAdmin/BuildingInstallation"} />
      }
      
        return (
            <div className="dbd_container">
                <div className="admin_page_titlebar">
                    <div className="admin_subheader">
                        <h2 className="dbd_sub_heading">Add Building</h2>
                        {/* <FaQuestionCircle className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" /> */}
                    </div>
                    <p className="sub_text">Complete this page to add a building.</p>
                </div>
                {Error_Message}
                <div className="main_container dbd_main_container">

                    <div className="">
                        <legend className="form_sub_title">Enter Building Information </legend>
                        <p>These required fields are used by the system and displayed on application and equipment pages as building identifiers.</p>

                        <div className="add_modifi form_group ">
                            <Label className="Custom_label">Name*</Label>
                            <input className="add_building custom_input default-input"  defaultValue={this.state.name_state} maxLength="50" onChange={e => this.setState({name_state: e.target.value})}  />&nbsp;<span className="ErrorMark" hidden={(parseInt(this.state.error_Code) % 2 != 1) }>!</span>
                        </div>

                        <div className="add_modifi form_group ">
                            <Label className="Custom_label">City*</Label>
                            <input className="add_building custom_input default-input" defaultValue={this.state.city_state} maxLength="50" onChange={e => this.setState({city_state: e.target.value})}  />&nbsp;<span className="ErrorMark" hidden={(!(parseInt(parseInt(this.state.error_Code) / 10) == 1 || parseInt(parseInt(this.state.error_Code) / 10) == 11 ))}>!</span>
                        </div>


                         <div className="add_modifi form_group ">
                            <Label className="Custom_label">Country/Region*</Label>
                            <select  className="add_building  Modal_input_regular" ref="select_country" onChange={e => this.selectCountry(Whole_Data,null)} >
                                {List_of_countries}
                            </select>
                        </div>

                          <div className="add_modifi form_group ">
                            <Label className="Custom_label">State*</Label>
                            <select  className="add_building  Modal_input_regular" ref="select_state" >
                                {states_list_from_resource_in_state}
                            </select>
                        </div>   


                         <div className="add_modifi form_group ">
                            <Label className="Custom_label">Time Zone*</Label>
                             <select className="add_building  Modal_input_regular" defaultValue={7}  ref={select => this.add_building_timezone = select} name="add_building_timezone"   >
                                                    <option value="1">[GMT-12:00] - International Date Line West</option>
                                                    <option value="2">[GMT-11:00] - Midway Island, Samoa</option>
                                                    <option value="3">[GMT-10:00] - Hawaiian-Aleutian Time</option>
                                                    <option value="4">[GMT-09:00] - Alaska Time</option>
                                                    <option value="5">[GMT-08:00] - Pacific Time</option>
                                                    <option value="6">[GMT-07:00] - Mountain Time</option>
                                                    <option  value="7">[GMT-06:00] - Central Time</option>
                                                    <option value="8">[GMT-05:00] - Eastern Time</option>
                                                    <option value="9">[GMT-04:30] - Caracas</option>
                                                    <option value="10">[GMT-04:00] - Atlantic Time</option>
                                                    <option value="11">[GMT-03:30] - Newfoundland Time</option>
                                                    <option value="12">[GMT-03:00] - Brazil</option>
                                                    <option value="13">[GMT-02:00] - Mid-Atlantic Time</option>
                                                    <option value="14">[GMT-01:00] - Azores</option>
                                                    <option value="15">[GMT] - Western European Time</option>
                                                    <option value="16">[GMT+01:00] - Central European Time</option>
                                                    <option value="17">[GMT+02:00] - Eastern European Time</option>
                                                    <option value="18">[GMT+03:00] - Moscow Time</option>
                                                    <option value="19">[GMT+04:00] - Caucasus Time</option>
                                                    <option value="20">[GMT+04:30] - Kabul</option>
                                                    <option value="21">[GMT+05:00] - Islamabad</option>
                                                    <option value="22">[GMT+05:30] - Mumbai</option>
                                                    <option value="23">[GMT+05:45] - Kathmandu</option>
                                                    <option value="24">[GMT+06:00] - Astana, Dhaka</option>
                                                    <option value="25">[GMT+06:30] - Yangoon</option>
                                                    <option value="26">[GMT+07:00] - Christmas Island Time</option>
                                                    <option value="27">[GMT+08:00] - Australian Western Time</option>
                                                    <option value="28">[GMT+09:00] - Seoul</option>
                                                    <option value="29">[GMT+09:30] - Australian Central Time</option>
                                                    <option value="30">[GMT+10:00] - Australian Eastern Time</option>
                                                    <option value="31">[GMT+11:00] - Magadan</option>
                                                    <option value="32">[GMT+11:30] - Norfolk (Island) Time</option>
                                                    <option value="33">[GMT+12:00] - Auckland</option>
                                                    <option value="34">[GMT+13:00] - Nuku'alofa</option>
                            </select>
                        </div>

                        <div className="add_modifi form_group ">
                            <Label className="Custom_label">Follows Daylight Saving Time*</Label>
                            <select className = "add_building  Modal_input_regular" defaultValue={true} ref ={select => this.add_daylightsaving = select} name="add_daylightsaving"   >
                            <option value ="false">No</option>
                            <option value ="true">Yes</option>
                            </select>
                        </div>

                        <div className="add_modifi form_group ">
                            <Label className="Custom_label">Serial Numbers*</Label>
                            <input className="add_building custom_input default-input" defaultValue={this.state.SerialNumber_state} onChange={e => this.setState({SerialNumber_state: e.target.value})}  />&nbsp;<span className="ErrorMark" hidden={(parseInt(this.state.error_Code) < 100) }>!</span>
                        </div>

                        <div className="add_modifi form_group ">
                            <Label className="Custom_label">User Name</Label>
                            <input className="add_building custom_input default-input"  onChange={e => this.setState({User_name_State: e.target.value})}  />&nbsp;<span className="ErrorMark" hidden={!this.state.username_error}>!</span>
                        </div>

                        <div className="add_modifi form_group ">
                            <Label className="Custom_label">Password</Label>
                            <input type="password" className="add_building custom_input default-input" onChange={e => this.setState({Password_State: e.target.value})}  />&nbsp;<span className="ErrorMark" hidden={!this.state.password_error}>!</span>
                        </div>
            
                        <FormGroup row className="btns_group">
                            <Col sm={{ size: 10 }}>
                                <Button className="btn-gray btn-md"  onClick={this.GoBack}  > {"<"} Back </Button>
                                <Button className="btn-success btn-md" onClick={this.AddBuilding_Submit} >Save </Button>
                            </Col>
                        </FormGroup>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
    Common_Resource_from_Store: state.CommonResourceDataRootReducer.CommonResourcesData,
    Add_New_Buildings_response: state.InstallationsRootReducer.AddNewBuildings,
    };
  };

const mapDispatchToProps = dispatch => {
return {
   getCommonResources_Action: () => dispatch(getCommonResources_Action()),
   AddNewBuildings: (data) => dispatch(AddNewBuildings(data))
};
}; 

export default connect(mapStateToProps, mapDispatchToProps)(AddNewBuilding);